// // // src/components/dashboard/SalesChart.jsx
// // import React, { useState, useEffect } from 'react';
// // import { 
// //   LineChart, 
// //   Line, 
// //   XAxis, 
// //   YAxis, 
// //   CartesianGrid, 
// //   Tooltip, 
// //   Legend, 
// //   ResponsiveContainer 
// // } from 'recharts';

// // const SalesChart = ({ data }) => {
// //   const [chartData, setChartData] = useState([]);
  
// //   // Format data for the chart
// //   useEffect(() => {
// //     if (!data || data.length === 0) return;
    
// //     // Format data based on the dateKey pattern
// //     const formattedData = data.map(item => {
// //       let formattedDate = item.date;
      
// //       // Check if the date is in ISO format (YYYY-MM-DD)
// //       if (item.date.includes('-')) {
// //         // Determine format based on length
// //         if (item.date.length === 10) { // YYYY-MM-DD
// //           // Format as DD/MM
// //           const date = new Date(item.date);
// //           formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
// //         } else if (item.date.length === 7) { // YYYY-MM
// //           // Format as MMM YYYY
// //           const date = new Date(`${item.date}-01`);
// //           formattedDate = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
// //         } else if (item.date.length === 13) { // YYYY-MM-DDTHH
// //           // Format as DD/MM HH:00
// //           const date = new Date(item.date + ':00:00');
// //           formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:00`;
// //         }
// //       }
      
// //       return {
// //         ...item,
// //         formattedDate
// //       };
// //     });
    
// //     setChartData(formattedData);
// //   }, [data]);
  
// //   // Format currency for tooltips
// //   const formatCurrency = (value) => {
// //     return new Intl.NumberFormat('en-IN', {
// //       style: 'currency',
// //       currency: 'INR',
// //       maximumFractionDigits: 0
// //     }).format(value);
// //   };
  
// //   // Custom tooltip for chart
// //   const CustomTooltip = ({ active, payload, label }) => {
// //     if (active && payload && payload.length) {
// //       return (
// //         <div className="bg-white p-3 shadow-md rounded-md border border-gray-200">
// //           <p className="text-sm font-medium text-gray-900 mb-1">{label}</p>
// //           <p className="text-sm text-orange-600">
// //             Sales: {formatCurrency(payload[0].value)}
// //           </p>
// //         </div>
// //       );
// //     }
    
// //     return null;
// //   };
  
// //   return (
// //     <div className="w-full h-80">
// //       {chartData.length > 0 ? (
// //         <ResponsiveContainer width="100%" height="100%">
// //           <LineChart
// //             data={chartData}
// //             margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
// //           >
// //             <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
// //             <XAxis 
// //               dataKey="formattedDate" 
// //               stroke="#6b7280"
// //               tick={{ fontSize: 12 }}
// //             />
// //             <YAxis 
// //               stroke="#6b7280"
// //               tick={{ fontSize: 12 }}
// //               tickFormatter={(value) => value.toLocaleString('en-IN')}
// //             />
// //             <Tooltip content={<CustomTooltip />} />
// //             <Legend />
// //             <Line 
// //               type="monotone" 
// //               dataKey="sales" 
// //               name="Sales" 
// //               stroke="#3b82f6" 
// //               activeDot={{ r: 8 }} 
// //               strokeWidth={2}
// //             />
// //           </LineChart>
// //         </ResponsiveContainer>
// //       ) : (
// //         <div className="w-full h-full flex items-center justify-center text-gray-500">
// //           <p>No sales data available for the selected period</p>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default SalesChart;

// // src/components/dashboard/SalesChart.jsx
// // Updated SalesChart.jsx with KPI support
// import React from 'react';
// import {
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer
// } from 'recharts';

// const SalesChart = ({ data, dataKey = 'value', color = '#3b82f6' }) => {
//   // Ensure we have valid data
//   if (!data || !Array.isArray(data) || data.length === 0) {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <div className="text-center">
//           <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//           </svg>
//           <h3 className="mt-2 text-sm font-medium text-gray-900">No Data Available</h3>
//           <p className="mt-1 text-sm text-gray-500">Chart will appear when data is available</p>
//         </div>
//       </div>
//     );
//   }

//   // Validate that each data point has the required properties
//   const validData = data.filter(item => 
//     item && 
//     typeof item === 'object' && 
//     'date' in item && 
//     dataKey in item &&
//     item.date !== null &&
//     item.date !== undefined
//   );

//   if (validData.length === 0) {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <div className="text-center">
//           <p className="text-sm text-gray-500">No valid data for selected period</p>
//         </div>
//       </div>
//     );
//   }

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return '';
    
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return dateString;
      
//       return new Intl.DateTimeFormat('en-US', { 
//         month: 'short', 
//         day: 'numeric' 
//       }).format(date);
//     } catch (error) {
//       return dateString;
//     }
//   };

//   // Format value based on data type and magnitude
// // In SalesChart.jsx, replace the formatValue function:
// const formatValue = (value) => {
//   if (value === null || value === undefined || isNaN(value)) {
//     return '0';
//   }

//   const numValue = Number(value);
  
//   // Determine if this is currency data based on the maximum value in the dataset
//   const maxDataValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
//   const isCurrencyData = maxDataValue >= 100; // Increased threshold
  
//   if (isCurrencyData) {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       maximumFractionDigits: 0
//     }).format(numValue);
//   } else {
//     // Treat as count
//     return `${numValue}`;
//   }
// };

//   // Get Y-axis formatter based on data range
// // Replace the getYAxisFormatter function:
// const getYAxisFormatter = (value) => {
//   const numValue = Number(value);
  
//   if (isNaN(numValue)) return '0';
  
//   // Determine if this is currency data
//   const maxDataValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
//   const isCurrencyData = maxDataValue >= 100;
  
//   if (isCurrencyData) {
//     if (numValue >= 100000) {
//       return `₹${(numValue/100000).toFixed(1)}L`;
//     } else if (numValue >= 1000) {
//       return `₹${(numValue/1000).toFixed(0)}k`;
//     } else {
//       return `₹${numValue}`;
//     }
//   } else {
//     return numValue.toString();
//   }
// };

//   // Custom tooltip component
//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length && payload[0]) {
//       const value = payload[0].value;
//       return (
//         <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-3">
//           <p className="font-medium text-gray-600">{formatDate(label)}</p>
//           <p className="font-semibold mt-1" style={{ color: color }}>
//             {formatValue(value)}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   // Create unique gradient ID
//   const gradientId = `color${dataKey}${Date.now()}`;

//   // Determine if data represents currency values
//   const maxValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
//   const isCurrencyData = maxValue >= 10;

//   return (
//     <ResponsiveContainer width="100%" height="100%">
//       <AreaChart
//         data={validData}
//         margin={{
//           top: 10,
//           right: 30,
//           left: isCurrencyData ? 40 : 20,
//           bottom: 0,
//         }}
//       >
//         <defs>
//           <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
//             <stop offset="5%" stopColor={color} stopOpacity={0.8} />
//             <stop offset="95%" stopColor={color} stopOpacity={0.1} />
//           </linearGradient>
//         </defs>
        
//         <CartesianGrid 
//           strokeDasharray="3 3" 
//           vertical={false} 
//           stroke="#f0f0f0" 
//         />
        
//         <XAxis 
//           dataKey="date" 
//           tickFormatter={formatDate}
//           axisLine={false}
//           tickLine={false}
//           dy={10}
//           tick={{ fill: '#9ca3af', fontSize: 12 }}
//           interval="preserveStartEnd"
//         />
        
//         <YAxis 
//           tickFormatter={getYAxisFormatter}
//           axisLine={false}
//           tickLine={false}
//           dx={-10}
//           tick={{ fill: '#9ca3af', fontSize: 12 }}
//           domain={['dataMin', 'dataMax']}
//         />
        
//         <Tooltip content={<CustomTooltip />} />
        
//         <Area 
//           type="monotone" 
//           dataKey={dataKey} 
//           stroke={color}
//           strokeWidth={3}
//           fill={`url(#${gradientId})`} 
//           activeDot={{ r: 6, fill: color, stroke: '#ffffff', strokeWidth: 2 }}
//           connectNulls={false}
//         />
//       </AreaChart>
//     </ResponsiveContainer>
//   );
// };

// export default SalesChart;


// src/components/dashboard/SalesChart.jsx
// Updated SalesChart.jsx with animated bar chart
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';

const SalesChart = ({ data, dataKey = 'value', color = '#3b82f6' }) => {
  // Ensure we have valid data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">No Data Available</h3>
          <p className="mt-1 text-sm text-gray-500">Chart will appear when data is available</p>
        </div>
      </div>
    );
  }

  // Validate that each data point has the required properties
  const validData = data.filter(item => 
    item && 
    typeof item === 'object' && 
    'date' in item && 
    dataKey in item &&
    item.date !== null &&
    item.date !== undefined
  );

  if (validData.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-sm text-gray-500">No valid data for selected period</p>
        </div>
      </div>
    );
  }

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      
      return new Intl.DateTimeFormat('en-US', { 
        month: 'short', 
        day: 'numeric' 
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  // Format value based on data type and magnitude
  const formatValue = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return '0';
    }

    const numValue = Number(value);
    
    // Determine if this is currency data based on the maximum value in the dataset
    const maxDataValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
    const isCurrencyData = maxDataValue >= 100; // Increased threshold
    
    if (isCurrencyData) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }).format(numValue);
    } else {
      // Treat as count
      return `${numValue}`;
    }
  };

  // Get Y-axis formatter based on data range
  const getYAxisFormatter = (value) => {
    const numValue = Number(value);
    
    if (isNaN(numValue)) return '0';
    
    // Determine if this is currency data
    const maxDataValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
    const isCurrencyData = maxDataValue >= 100;
    
    if (isCurrencyData) {
      if (numValue >= 100000) {
        return `₹${(numValue/100000).toFixed(1)}L`;
      } else if (numValue >= 1000) {
        return `₹${(numValue/1000).toFixed(0)}k`;
      } else {
        return `₹${numValue}`;
      }
    } else {
      return numValue.toString();
    }
  };

  // Create gradient colors for bars
  const createGradientColors = (baseColor) => {
    // Convert hex to RGB for gradient calculations
    const hexToRgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    };

    const rgb = hexToRgb(baseColor);
    if (!rgb) return [baseColor];

    // Create variations of the base color
    return validData.map((_, index) => {
      const intensity = 0.6 + (0.4 * (index / Math.max(1, validData.length - 1)));
      return `rgb(${Math.round(rgb.r * intensity)}, ${Math.round(rgb.g * intensity)}, ${Math.round(rgb.b * intensity)})`;
    });
  };

  // Get bar colors with gradient effect
  const getBarColor = (entry, index) => {
    const value = Number(entry[dataKey]) || 0;
    const maxValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
    
    if (maxValue === 0) return color;
    
    // Create intensity based on value (higher values get more intense colors)
    const intensity = 0.4 + (0.6 * (value / maxValue));
    
    // Convert hex color to RGB and apply intensity
    const hexToRgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : { r: 59, g: 130, b: 246 }; // Default blue
    };

    const rgb = hexToRgb(color);
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${intensity})`;
  };

  // Custom tooltip component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length && payload[0]) {
      const value = payload[0].value;
      return (
        <div className="bg-white border border-gray-200 shadow-xl rounded-lg p-4 transform transition-all duration-200">
          <div className="flex items-center space-x-2 mb-2">
            <div 
              className="w-3 h-3 rounded-full" 
              style={{ backgroundColor: color }}
            ></div>
            <p className="font-medium text-gray-700">{formatDate(label)}</p>
          </div>
          <p className="font-bold text-lg" style={{ color: color }}>
            {formatValue(value)}
          </p>
        </div>
      );
    }
    return null;
  };

  // Custom bar shape with rounded corners and animations
  const CustomBar = (props) => {
    const { fill, x, y, width, height } = props;
    const radius = Math.min(width * 0.1, 4); // Rounded corners
    
    return (
      <g>
        {/* Subtle shadow */}
        <rect
          x={x + 1}
          y={y + 1}
          width={width}
          height={height}
          fill="rgba(0,0,0,0.1)"
          rx={radius}
          ry={radius}
        />
        {/* Main bar with gradient effect */}
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill={fill}
          rx={radius}
          ry={radius}
          className="transition-all duration-500 ease-in-out hover:brightness-110"
          style={{
            background: `linear-gradient(to top, ${fill}, ${fill}dd)`,
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
          }}
        />
        {/* Highlight on top */}
        <rect
          x={x}
          y={y}
          width={width}
          height={Math.max(height * 0.3, 4)}
          fill="rgba(255,255,255,0.2)"
          rx={radius}
          ry={radius}
        />
      </g>
    );
  };

  // Determine if data represents currency values
  const maxValue = Math.max(...validData.map(item => Number(item[dataKey]) || 0));
  const isCurrencyData = maxValue >= 10;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={validData}
        margin={{
          top: 20,
          right: 30,
          left: isCurrencyData ? 50 : 20,
          bottom: 5,
        }}
        barCategoryGap="20%"
      >
        {/* Subtle grid */}
        <CartesianGrid 
          strokeDasharray="3 3" 
          vertical={false} 
          stroke="#f0f0f0"
          strokeOpacity={0.6}
        />
        
        {/* X-Axis */}
        <XAxis 
          dataKey="date" 
          tickFormatter={formatDate}
          axisLine={false}
          tickLine={false}
          dy={10}
          tick={{ 
            fill: '#6b7280', 
            fontSize: 12,
            fontWeight: 500
          }}
          interval="preserveStartEnd"
        />
        
        {/* Y-Axis */}
        <YAxis 
          tickFormatter={getYAxisFormatter}
          axisLine={false}
          tickLine={false}
          dx={-10}
          tick={{ 
            fill: '#6b7280', 
            fontSize: 12,
            fontWeight: 500
          }}
          domain={['dataMin', 'dataMax']}
        />
        
        {/* Custom Tooltip */}
        <Tooltip 
          content={<CustomTooltip />}
          cursor={{ fill: 'rgba(59, 130, 246, 0.1)' }}
        />
        
        {/* Animated Bar */}
        <Bar 
          dataKey={dataKey} 
          fill={color}
          radius={[4, 4, 0, 0]}
          animationDuration={1000}
          animationEasing="ease-out"
          shape={<CustomBar />}
        >
          {/* Individual bar colors with gradient effect */}
          {validData.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={getBarColor(entry, index)}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SalesChart;